// src/components/Navbar.tsx
import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import cccLogo from "../logo/ccc-logo-hfull-3c.png";
import BackButton from "./BackButton";
import ProfileMenu from "./ProfileMenu";
import SidePanel from "./SidePanel";

interface NavbarProps {
  pageTitle?: string;
}

const Navbar: React.FC<NavbarProps> = () => {
  const { dashboards, isAuthenticated, user, logout, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isDashboardViewerPage, setIsDashboardViewerPage] =
    React.useState(false);

  const [isSidePanelOpen, setIsSidePanelOpen] = React.useState(false);

  React.useEffect(() => {
    if (
      dashboards &&
      dashboards.length > 1 &&
      location.pathname.startsWith("/dashboard/")
    ) {
      setIsDashboardViewerPage(true);
    }
  }, [dashboards, location.pathname]);

  return (
    <>
      <header className="navbar">
        {/* Main navbar area */}
        <div className={`navbar-main ${(!isAuthenticated || !isDashboardViewerPage) ? 'navbar-main-thin' : ''}`}>
          <div className="navbar-main-left">
            {isAuthenticated && (
              <button
                type="button"
                className="hamburger-btn"
                aria-label="Open menu"
                onClick={() => setIsSidePanelOpen(true)}
              >
                <span className="hamburger-lines" aria-hidden="true">
                  <span />
                  <span />
                  <span />
                </span>
              </button>
            )}

            <img
              src={cccLogo}
              alt="California Community Colleges"
              className="navbar-logo navbar-logo-clickable"
              onClick={() => {
                navigate(location.pathname, { replace: true });
              }}
            />
          </div>

          <div className="navbar-right">
            {isAuthenticated ? (
              <>
                {isDashboardViewerPage && (
                  <BackButton className="btn-primary" fallbackPath="/dashboard" />
                )}
                <ProfileMenu
                  orgName={user?.district || ""}
                  orgSubtext=""
                  signedInUser={{
                    name: user?.name || "",
                    email: user?.email || "",
                  }}
                  activeAccountId="1"
                  onSignOut={logout}
                  onAccountSelect={(id) => console.log("select", id)}
                  onViewAccount={() => console.log("view account")}
                  onSwitchOrganization={() => console.log("switch org")}
                  onSignInDifferent={() => login(user.districtKey)}
                />
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </header>

      {isAuthenticated && (
        <SidePanel
          open={isSidePanelOpen}
          onClose={() => setIsSidePanelOpen(false)}
          user={{
            name: user?.name || "",
            email: user?.email || "",
          }}
          onNavigate={(key) => {
            // Plug your routing here later. For now just log.
            console.log("sidepanel navigate:", key);

            // Example:
            // if (key === "myApps") navigate("/apps");
            // if (key === "account_devices") navigate("/account/devices");
          }}
        />
      )}
    </>
  );
};

export default Navbar;
